export default () => {
	/* If not IE add text */
	if (!document.body.classList.contains('msie')) {
		const countries = [...document.querySelectorAll('.svg__correct')];
		const namesOfCountries = [...document.querySelectorAll('.svg__text')];
		countries.forEach((country, i) => country.addEventListener("mouseenter", (e) => {
			let idElement = country.getAttribute('id');
			namesOfCountries.map(nameOfCountry => {
				let classList = [...nameOfCountry.classList];
				let isClass = classList.find((singleClass) => singleClass == idElement);
				if (isClass) {
					nameOfCountry.classList.add('svg__text--isColor');
				} else {
					nameOfCountry.classList.remove('svg__text--isColor');
				}
			});
		}))
		const svg = document.querySelector('.svg__group');
		svg.addEventListener('mouseleave', () => {
			namesOfCountries.map(el => {
				el.classList.remove('svg__text--isColor');
			});
		});
	}

	/* If IE animate lines */
	if (document.body.classList.contains('msie')) {
		let allLinePaths = [...document.querySelectorAll('.path')]
		let offsetPath = 800

		let animateLinePaths = function () {
			if (offsetPath == 0) offsetPath = 0
			allLinePaths.forEach(linePath => linePath.style.strokeDashoffset = offsetPath)
			offsetPath--;

			requestAnimationFrame(animateLinePaths)
		}
		animateLinePaths()
	}
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/mapInfo.js